

import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { UsuarioService } from 'src/app/shared/services/usuario.service';

@Injectable({
  providedIn: 'root'
})
export class ListUsuarioResolver implements Resolve<boolean> {

  constructor(private service: UsuarioService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}